module.exports = __webpack_public_path__ + "static/animation-talk-desk-4c18e7c6a0b02acb6bcef7a8794362ec.png";